import { v4 as uuidv4 } from 'uuid'

export const generateId = (index: number) =>
  `carousel-slide-${index}-${uuidv4()}`
